import React, { useState } from 'react';
import { AccordionListItem } from 'components/Button';
import { Button, Stack, Typography } from '@mui/material';
import { Modal } from 'components/Modal';
import { useUpdateCompanyValidatedStatus } from '../api/updateCompanyValidatedStatus';

export const ValidateToggleButton = ({ validated, refetch }) => {
  const { mutateAsync } = useUpdateCompanyValidatedStatus(refetch);

  const [open, setOpen] = useState(false);

  const handleCloseModal = () => setOpen(false);

  const handleUpdate = () =>
    mutateAsync(!validated)
      .then(handleCloseModal)
      .catch(() => {});

  return (
    <>
      <AccordionListItem onClick={() => setOpen(true)}>
        {validated ? 'Unvalidate' : 'Validate'}
      </AccordionListItem>

      <Modal open={open} handleClose={handleCloseModal} title="Validate supplier">
        <Typography variant="body1" fontWeight={500}>
          Are you sure you want to set the company status to{' '}
          <span style={{ fontWeight: 'bold' }}>
            {validated ? 'unvalidated' : 'validated'}?{' '}
          </span>
        </Typography>

        <Stack direction="row" justifyContent="center" gap={1}>
          <Button variant="outlined" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleUpdate}>
            Confirm
          </Button>
        </Stack>
      </Modal>
    </>
  );
};
